import { GlobeAltIcon, LockClosedIcon } from '@heroicons/react/24/outline';
import { ButtonHTMLAttributes } from 'react';

type VisibilityIconButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  isPublic: boolean;
  label?: string;
};

export function VisibilityIconButton({
  isPublic,
  label,
  className = '',
  ...props
}: VisibilityIconButtonProps) {
  const resolvedLabel = label ?? (isPublic ? 'Tornar privado' : 'Tornar público');
  const Icon = isPublic ? LockClosedIcon : GlobeAltIcon;

  return (
    <button
      type="button"
      title={resolvedLabel}
      aria-label={resolvedLabel}
      className={`inline-flex items-center justify-center rounded-md p-1.5 text-secondary-500 transition-colors hover:bg-primary-50 hover:text-primary-600 ${className}`}
      {...props}
    >
      <Icon className="h-5 w-5" />
    </button>
  );
}
